import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { orderBy } from 'lodash';
import Meaning from 'components/vocab/meaning';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

@observer
class MeaningsList extends React.Component {
  @computed get meanings() {
    if (!this.props.word || !this.props.word.meanings) return [];
    return orderBy(this.props.word.meanings, 'score', 'desc');
  }

  @computed get filteredMeanings() {
    return this.meanings.filter(meaning => {
      return meaning.sourcesForUser(AppUI.user).length > 0;
    });
  }

  @computed get fontSize() {
    return this.props.fontSize || (AppUI.layout.isMobile ? '13px' : '16px');
  }

  @computed get lineHeight() {
    return this.props.lineHeight || (AppUI.layout.isMobile ? '17px' : '22px');
  }

  render() {
    if (!this.filteredMeanings || this.filteredMeanings.length === 0) {
      return null;
    }
    return (
      <Wrapper>
        {
          this.filteredMeanings.map(meaning => (
            <Meaning
              key={meaning.id}
              meaning={meaning}
              word={this.props.word}
              user={AppUI.user}
              onClickWord={this.props.onClickWord}
              hideLevels={this.props.hideLevels}
              lineHeight={this.lineHeight}
            />
          ))
        }
      </Wrapper>
    );
  }
}

export default MeaningsList;